import styled from 'styled-components';
import { fromMd } from '../../../constants/breakpoints';
import { gridColumnCount, gutterHalf } from '../constants';
export const Column = styled.div(({ desktop, desktopOffset, mobile, mobileOffset = 0, hasGutter = true, isVerticalAlign = false, }) => {
    const mobileWidth = mobile !== undefined ? `calc(100% * ${mobile} / ${gridColumnCount})` : '100%';
    const desktopWidth = desktop !== undefined || mobile !== undefined
        ? `calc(100% * ${desktop !== undefined ? desktop : mobile} / ${gridColumnCount})`
        : '100%';
    return {
        alignSelf: isVerticalAlign ? 'center' : 'unset',
        boxSizing: 'border-box',
        flexGrow: 1,
        marginLeft: `calc(100% * ${mobileOffset} / ${gridColumnCount})`,
        minWidth: mobileWidth,
        maxWidth: mobileWidth,
        padding: hasGutter ? gutterHalf : '0',
        [fromMd]: {
            marginLeft: `calc(100% * ${desktopOffset || mobileOffset} / ${gridColumnCount})`,
            minWidth: desktopWidth,
            maxWidth: desktopWidth,
            padding: hasGutter ? gutterHalf : '0',
        },
    };
});
//# sourceMappingURL=index.js.map